import React from 'react';
import cn from 'classnames';
import Select from '@dealroadshow/uikit-select';
import { IFileUploadNotificationSettingsPayload } from '../../../domain/vo/FileUploadEmailAlerts';
import {
  IStagingFileUploadNotificationSettingsPayload,
} from '../../../domain/vo/StagingFileUploadEmailAlerts';
import { IAccessRequestNotificationSettingsPayload } from '../../../domain/vo/AccessRequestEmailAlerts';
import { IQuestionsNotificationSettingsPayload } from '../../../domain/vo/QuestionsEmailAlerts';
import styles from './selectField.module.scss';

interface IProps<T> {
  selectClassName: string,
  options: { label: string, value: string }[],
  name: keyof Exclude<T, keyof T & `is${ string }`> & string,
  value: string | string[],
  onChange: (
    name: keyof Exclude<T, keyof T & `is${ string }`>,
    value: T[keyof Omit<T, keyof T & `is${ string }`>],
  ) => void,
  disabled: boolean,
  dataTest: string,
  isMulti?: boolean,
  error?: string,
}

const SelectField = <T = IFileUploadNotificationSettingsPayload |
  IStagingFileUploadNotificationSettingsPayload |
  IAccessRequestNotificationSettingsPayload |
  IQuestionsNotificationSettingsPayload,
>({
  selectClassName,
  options,
  name,
  value,
  onChange,
  disabled,
  dataTest,
  isMulti,
  error,
}: IProps<T>) => {
  const selectedValue = isMulti
    ? options.filter(({ value: optionValue }) => value.includes(optionValue))
    : options.find(({ value: optionValue }) => optionValue === value) || null;

  return (
    <Select
      selectClassName={ cn(styles.select, selectClassName) }
      onChange={ (option: any) => onChange(name, isMulti ? option.map(({ value }: { value: string }) => value) : option?.value) }
      name={ name }
      // @ts-ignore TODO: strictNullChecks
      value={ selectedValue }
      options={ options }
      isNarrow
      isDisabled={ disabled }
      dataTest={ dataTest }
      // @ts-ignore
      selectStyles={ { menu: (base) => Object.assign(base, { position: 'static' }) } }
      meta={ {
        touched: !!error,
        error,
      } }
      isMulti={ isMulti }
    />
  );
};

export default SelectField;
